module.exports = __webpack_public_path__ + "img/个人微信.551d4528.jpg";